define('views/modules/modal/thumbnail-modal',[
    // Libs
    'backbone',
    'mustache',
    // services
    'services/i18n',
    // views
    'views/parts/modal/modal'

], function(
    // Libs
    Backbone, Mustache,
    // services
    i18n,
    // views
    VModal
) {
    var VThumbnailModal = VModal.extend({
        template: "<img src='{{imageUrl}}' onerror=\"this.src='assets/images/placeholer-image.jpg';\">",

        modal: function() {
            return { title: this.imageName };
        },

        buttons: function() {
            return {
                confirm: {
                    label: i18n.t("Ok"),
                }
            };
        },

        initialize: function(imageUrl, imageName) {
            this.imageUrl = imageUrl;
            this.imageName = imageName;
        },

        render: function() {
            var html = Mustache.render(this.template, Mustache.getContext({ imageUrl: this.imageUrl }));
            this.$el.empty().append(html);
            this.renderModal();

            return this;
        },

    });

    return VThumbnailModal;
});

